import { RULES_OF_USE_BANNER_HEADER_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[RULES_OF_USE_BANNER_HEADER_MODULE_ID]: {
		moduleType: 'bannerHeader',
		bannerImageText: 'Rules of Use',
		bannerSubText: '',
	},
}
